import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React, { useContext } from 'react';
import { StepperPageContext } from '../../../context';
import Button from '../../Button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: theme.spacing(2.5),
      justifyContent: 'end',
    },
  }),
);

export const StepNavigationActions: React.FC = () => {
  const classes = useStyles();
  const { onNext, onBack, activeStepIndex, activeStep } = useContext(
    StepperPageContext,
  );

  return (
    <div className={classes.root}>
      {activeStepIndex > 0 && (
        <Button
          htmlId="go-back-button"
          variant="contained"
          size="small"
          color="secondary"
          onClick={onBack}
          data-testid="go-back-button"
        >
          Go back
        </Button>
      )}
      <Button
        htmlId="go-next-button"
        variant="contained"
        color="secondary"
        size="small"
        onClick={onNext}
        disabled={!activeStep?.complete}
        data-testid="go-next-button"
      >
        Next
      </Button>
    </div>
  );
};
